/**
 * @generated SignedSource<<edf46ac4789ec8c8a5ebc597a0e606e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vppId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VppUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateVppTPayload",
        "kind": "LinkedField",
        "name": "updateVppTByVppId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VppT",
            "kind": "LinkedField",
            "name": "vppT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VppUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateVppTPayload",
        "kind": "LinkedField",
        "name": "updateVppTByVppId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VppT",
            "kind": "LinkedField",
            "name": "vppT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b79c7c1785e97f85110e706de48721ba",
    "id": null,
    "metadata": {},
    "name": "VppUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation VppUpdateMutation(\n  $input: UpdateVppTByVppIdInput!\n) {\n  updateVppTByVppId(input: $input) {\n    vppT {\n      vppId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "999a8e0df913cd49cf527cf2e925651c";

module.exports = node;
